export default "__VITE_ASSET__C8WjHzNA__"